import { create } from "zustand";

const userActivePage = create((set) => ({
  isActive: "",

  setIsActive: ({ setPage }) => {
    set({ isActive: setPage });
  },
}));

export default userActivePage;
